<script>

	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	import './style.scss'

	import {
		REGISTER_ACCOUNT,
		COMPANY_LIST,
		URL_PREFIX,
	} from '@/constants'

	import {
		capitalizeFirstLetter,
	} from '@/lib/utils'

	export default {
		name: 'signup',
		components: {
			ClipLoader
		},
		data: () => ({
			email: process.env.NODE_ENV === 'development' ? `user+${Math.floor(Math.random() * Math.floor(2000))}@example.com` : '',
			password: process.env.NODE_ENV === 'development' ? 'password' : '',
			errorMessage: null,
			loading: false,
			color: '#fff',
			companyList: COMPANY_LIST,
			registered: false,
			paid: false,
			timeout: false,
			selected: {
				title: 'Google',
				icon: '/static/companies/icons/google-icon.svg',
				url: `${URL_PREFIX}/company/google`
			},
		}),
		beforeCreate () {
			this.REGISTER_ACCOUNT = REGISTER_ACCOUNT
		},
		methods: {
			setLoading (loadingState) {
				this.loading = loadingState;
			},
			successSignUp(resBody) {
				const { userId, token } = resBody;
				this.registered = true;
				this.$eventHub.$emit('notification', {
					show: true,
					type: 'success',
					message: 'You\'ve been registered! :)',
					duration: 5000,
				});
				this.setLoading(false);
				window.location.href = `${URL_PREFIX}/company/${this.selected.title.toLowerCase()}`
			},
			errorSignUp(e) {
				this.setLoading(false);
				this.$eventHub.$emit('notification', {
					show: true,
					type: 'error',
					message: e.error,
					duration: 5000,
				});
			},
			async registerAccount() {
				window.location.href = `${URL_PREFIX}/company/${this.selected.title.toLowerCase()}`
				/**
				this.setLoading(true);
				const { email, password } = this;
				try {
					const response = await fetch('/api/auth/register', {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', },
						body: JSON.stringify({ email, password })
					})
					const resBody = await response.json();
					if (!response.ok) {
						throw resBody;
					} else {
						this.successSignUp(resBody);
					}
				} catch (e) {
					this.errorSignUp(e);
					this.setLoading(false)
				}
				*/
			},
		}
	}

</script>

<template>
	<div class='signup'>
		<div class='signup-container'>
			<header>
				Ace your interview now!
			</header>
			<form autocomplete='off' class='form-container'>
				<v-select
					ref='select'
					v-model='selected'
					:options='companyList'
					label='title'
					:disabled='loading === true || (registered === true && paid === true && timeout === true)'
				>
					<span class='no-results' slot="no-options">No matching companies.</span>
					<template slot='option' slot-scope='option' >
						<img class='company-icon' :src='option.icon'>
						{{ option.title }}
					</template>
					<template slot='selected-option' slot-scope='option'>
						<img class='company-icon' :src='option.icon'>
						{{ option.title }}
					</template>
				</v-select>
				<button
					:disabled='loading === true && registered === true && paid === true'
					:class='{ submit: true, loading: loading === true }'
					@click='registerAccount()'
					type='button'>
					<span v-if='loading === false && timeout === false'>
						See Interview Topics&nbsp;&nbsp;&nbsp;⟶
					</span>
					<span v-if='loading === true && registered === false && paid === false'>
						Signing Up...&nbsp;&nbsp;&nbsp;
					</span>
					<span v-if='loading === true && registered === true && paid === false'>
						Awaiting Payment...&nbsp;&nbsp;&nbsp;
					</span>
					<span v-if='loading === false && registered === true && paid === true && timeout === true'>
						Subscribed!
					</span>
					<ClipLoader
						:loading='loading'
						:color='color'
					/>
				</button>
			</form>
		</div>
		<!--<p class='account-tos'>
			By signing up you agree to be awesome
			<a href="/legal/terms/">Terms of Service</a>.
		</p>-->
	</div>
</template>



// WEBPACK FOOTER //
// src/components/SignUp/SignUp.vue